import { createElement } from "react";
import React from "react";
import { ThemeType, ContextMsg, useCtx } from "./Context.jsx";
import { useFeliz_React__React_useResponsive_Static_Z434A9929 } from "./fable_modules/Feliz.UseMediaQuery.1.5.0/UseMediaQuery.fs.js";
import { int32ToString, equals, createObj } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { singleton, append, delay, toList } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import { Divider, Persona, Link, Text as Text$, tokens, Button, Hamburger } from "@fluentui/react-components";
import { AlertRegular, DarkThemeRegular, SearchRegular } from "@fluentui/react-icons";
import { reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { ofArray } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { RouterModule_encodeParts } from "./fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { defaultArg } from "./fable_modules/fable-library-js.4.24.0/Option.js";
import { reactApi as reactApi_1 } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";

export function Headerbar() {
    let elems_5, elems_4, el_22;
    const patternInput = useCtx();
    const setCtx = patternInput[1];
    const ctx = patternInput[0];
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    return createElement("div", createObj(ofArray([["style", {
        height: 60,
        display: "flex",
        flexDirection: "column",
    }], (elems_5 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        justifyContent: "space-between",
        paddingRight: 25,
        alignItems: "center",
    }], (elems_4 = toList(delay(() => {
        let matchValue, el;
        return append((matchValue = screenSize, (matchValue.tag === 0) ? singleton((el = Hamburger, createElement(el, {
            onClick: (ev) => {
                ev.stopPropagation();
                setCtx(new ContextMsg(3, [!ctx.NavbarOpen]));
            },
        }))) : ((matchValue.tag === 1) ? singleton((el = Hamburger, createElement(el, {
            onClick: (ev) => {
                ev.stopPropagation();
                setCtx(new ContextMsg(3, [!ctx.NavbarOpen]));
            },
        }))) : ((matchValue.tag === 2) ? singleton((el = Hamburger, createElement(el, {
            onClick: (ev) => {
                ev.stopPropagation();
                setCtx(new ContextMsg(3, [!ctx.NavbarOpen]));
            },
        }))) : singleton(createElement("div", {}))))), delay(() => {
            let matchValue_1, el_6, el_2, elems, el_4;
            return append((matchValue_1 = screenSize, (matchValue_1.tag === 0) ? singleton(createElement("div", {})) : ((matchValue_1.tag === 1) ? singleton(createElement("div", {})) : ((matchValue_1.tag === 2) ? singleton(createElement("div", {})) : singleton((el_6 = Button, createElement(el_6, createObj(ofArray([["style", {
                width: 350,
                display: "flex",
                justifyContent: "start",
                gap: 10 + "px ",
                borderColor: tokens.colorNeutralStroke1,
            }], ["icon", (el_2 = SearchRegular, createElement(el_2, {}))], ["iconPosition", "before"], ["appearance", "subtle"], ["size", "large"], (elems = [(el_4 = Text$, createElement(el_4, {
                children: "Søk...",
            })), createElement("div", {})], ["children", reactApi.Children.toArray(Array.from(elems))])])))))))), delay(() => {
                let elems_3, el_10, el_8, el_14, el_12, el_20, elems_2, el_18, elems_1, el_16;
                return singleton(createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    gap: 10 + "px ",
                }], (elems_3 = [(el_10 = Button, createElement(el_10, {
                    icon: (el_8 = DarkThemeRegular, createElement(el_8, {})),
                    size: "large",
                    appearance: "transparent",
                    onClick: (_arg) => {
                        if (equals(ctx.ThemeType, new ThemeType(0, []))) {
                            setCtx(new ContextMsg(4, [new ThemeType(1, [])]));
                        }
                        else {
                            setCtx(new ContextMsg(4, [new ThemeType(0, [])]));
                        }
                    },
                })), (el_14 = Button, createElement(el_14, {
                    icon: (el_12 = AlertRegular, createElement(el_12, {})),
                    size: "large",
                    appearance: "transparent",
                })), (el_20 = Link, createElement(el_20, createObj(ofArray([["href", RouterModule_encodeParts(ofArray(["bruker", int32ToString(ctx.User.Id)]), 1)], (elems_2 = [(el_18 = Button, createElement(el_18, createObj(ofArray([["size", "large"], ["appearance", "transparent"], (elems_1 = [(el_16 = Persona, createElement(el_16, createObj(toList(delay(() => append(singleton(["name", `${ctx.User.FirstName} ${ctx.User.LastName}`]), delay(() => {
                    let matchValue_2;
                    return append((matchValue_2 = ctx.User.Workplace, (matchValue_2 != null) ? singleton(["secondaryText", `${matchValue_2.Region.Name}`]) : singleton(["secondaryText", "Ingen Region"])), delay(() => append(singleton(["size", "extra-large"]), delay(() => singleton(["avatar", {
                        color: "cranberry",
                        image: {
                            src: defaultArg(ctx.User.ImageUrl, ""),
                        },
                    }])))));
                })))))))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))))], ["children", reactApi_1.Children.toArray(Array.from(elems_3))])]))));
            }));
        }));
    })), ["children", reactApi_1.Children.toArray(Array.from(elems_4))])]))), (el_22 = Divider, createElement(el_22, {
        appearance: "subtle",
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_5))])])));
}

//# sourceMappingURL=Headerbar.jsx.map
